import { Redirect } from "@outschool/ui-utils";
import React from "react";

const RedirectWrapper = ({ to }: { to: string }) => {
  return <Redirect to={to} />;
};

export default RedirectWrapper;
